module.exports = __webpack_public_path__ + "img/weilai-logo.d4c05d33.png";